import styles from './RadioButton.module.css';

export const RadioButton: React.FC<
  { label: string; variant?: string; inputClassName?: string } & React.InputHTMLAttributes<HTMLInputElement>
> = ({ label, variant = 'primary', className, checked, inputClassName, tabIndex, ...props }) => {
  const variantClasses = {
    secondary: styles.secondary,
    primary: styles.primary,
  }[variant];

  return (
    <label
      className={`bg-neutral focus:bg-secondary border-primary-400 inline-block w-[33%] rounded border-1 py-3 text-center text-sm text-[#A8A8A8] ${variantClasses} ${styles.radioButtonLabel} ${className ? className : ''} ${checked ? styles.checked : ''}`}
    >
      <input {...props} type="radio" className={`${styles.radioButton} ${inputClassName}`} tabIndex={tabIndex} />
      {label}
    </label>
  );
};
